import React from 'react';
import Header from '../Common/Header';
import Footer from '../Common/Footer';
import HomeSlider from '../Elements/HomeSlider';
import DataProtection from '../Elements/Services2';
import Services from '../Elements/Services';

class Home extends React.Component {
    render() {
        return (
            <>
                <Header />
                <div className="page-content">
                    <HomeSlider />
                    <Services />
                    <DataProtection />
                </div>
                <Footer />
            </>
        );
    };
};

export default Home;